import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import Solutions from './pages/Solutions/Solutions';
import Trade from './pages/Trade/Trade';
import Customs from './pages/Customs/Customs';
import Investment from './pages/Investment/Investment';
import Stock from './pages/Stock/Stock';
import Contact from './pages/Contact/Contact';
import ProductDetail from './pages/ProductDetail/ProductDetail';
import About from './pages/About/About';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/trade" element={<Trade />} />
        <Route path="/customs" element={<Customs />} />
        <Route path="/investment" element={<Investment />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/products/:id" element={<ProductDetail />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default App; 